<style scoped lang="scss">
    .tail_main {
        margin-top: 55px !important;
        .van-collapse {
            position: fixed;
            top: 46px;
            left: 0;
            width: 100%;
            z-index: 1000;
        }
        .small {
            padding: 5px 15px;
            .van-field {
                padding: 0 15px;
            }
        }
        .time {
            .van-cell__value {
                flex: 2;
            }
        }
        .products {
            margin: 0;
            padding: 10px 15px;
            background:#f5f5f5;
            dl {
                margin: 6px 0;
                padding: 0;
            }
            dt {
                margin: 0;
                padding: 0;
                float: left;
                width: 88%;
            }
            dd {
                margin: 0;
                padding: 0;
                line-height: 1.5;
                float: right;
                color: #999;
            }
        }
        .tail_receiptor_title {
            padding: 10px 15px;
            color: #1fc295;
            .red {
                margin-left: 6px;
                color: #ff0000 !important;
            }
        }
        ::v-deep .tail_idcardno {
            .van-field__control {
                text-align: right;
            }
        }
        .tail_upload_box {
            padding:0 15px 15px;
            .title {
                display: inline-block;
                padding: 6px 0;
            }
            .uploads {
                margin: 5px auto;
                width:100%;
                height:auto;
                min-height:100px;
                border:1px dashed #dddddd;
            }
            .uploads span {
                display: block;
                width:100%;
                height: 100%;
                text-align: center;
                i {
                    display: inline-block;
                    width:100%;
                    height:100px;
                    line-height: 100px;
                    font-style: normal;
                    color: #999;
                }
                img {
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    .tail_btn_box {
        width: 96%;
        margin:0 auto;
        padding-bottom: 100px;
    }
</style>

<template>
    <div>
        <!--展示-->
        <div class="Show">
            <van-nav-bar
                    title="身份确认-快递跟踪"
                    left-text=""
                    left-arrow
                    @click-left="closeTail()">
            </van-nav-bar>
            <div class="cmain tail_main">
                <div class="tail_receiptor_title">商品信息
                    <el-button type="danger" style="float: right; margin-top:-5px;" size="mini" @click="toTail()">快递跟踪</el-button>
                </div>
                <van-cell-group>
                    <div class="products">
                        <dl v-for="item in expItem.items">
                            <dt>{{item.productName}}</dt>
                            <dd>x{{item.quantity}}</dd>
                            <div class="clearb"></div>
                        </dl>
                    </div>
                    <van-cell v-if="expItem.expressNo" class="small time">
                        <span slot="title">{{expItem.expressTypeDesc || '快递单号'}}</span>
                        <span>{{expItem.expressNo}}</span>
                    </van-cell>
                    <van-cell class="small time">
                        <span slot="title">创建时间</span>
                        <span>{{expItem.auCreationTime}}</span>
                    </van-cell>
                    <van-cell v-if="expItem.packedTime" class="small time">
                        <span slot="title">邮寄时间</span>
                        <span>{{expItem.packedTime}}</span>
                    </van-cell>
                </van-cell-group>
                <div class="tail_receiptor_title">收件人信息<span class="red">(身份证信息必须上传)</span></div>
                <van-cell-group>
                    <van-cell class="small time">
                        <span slot="title">收件人姓名</span>
                        <span>{{expItem.addressee && expItem.addressee.name}}</span>
                    </van-cell>
                    <van-field
                        clearable
                        v-model="expItem.addressee && expItem.addressee.idCardNo"
                        label="身份证号"
                        class="tail_idcardno"
                        placeholder="请输入身份证号"
                    />
                    <div class="tail_upload_box">
                        <span class="title">请上传身份证</span>
                        <van-uploader class="uploads"
                            accept="image/*"
                            :before-read="beforeAvatarUpload"
                            :after-read="idCardFrontImageSuccess"
                        >
                            <span>
                                <i v-if="!expItem.addressee || !expItem.addressee.idCardFrontImageUrl">点击上传身份证人面像</i>
                                <img v-else :src="expItem.addressee && expItem.addressee.idCardFrontImageUrl" />
                            </span>
                        </van-uploader>
                        <van-uploader class="uploads"
                            accept="image/*"
                            :before-read="beforeAvatarUpload"
                            :after-read="idCardBackImageSuccess"
                        >
                            <span>
                                <i v-if="!expItem.addressee || !expItem.addressee.idCardBackImageUrl">点击上传身份证国徽像</i>
                                <img v-else :src="expItem.addressee && expItem.addressee.idCardBackImageUrl" />
                            </span>
                        </van-uploader>
                    </div>
                </van-cell-group>
            </div>
            <div class="tail_btn_box">
                <van-button type="primary" style="margin-bottom: 6px;" size="large" @click="save()">保存身份证</van-button>
                <van-button type="danger" size="large" @click="toTail()">快递跟踪</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import lrz from 'lrz'
import { Cell, CellGroup } from 'vant';
export default {
    name: "tail",
    props: {
        expId: {
            default: 0,
            type: Number
        }
    },
    components: {
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
    },
    data() {
        return {
            //tailIsShow: true,
            curExpId: this.expId,
            expItem: {},
            expressSearchUrl: ""
        }
    },
    watch: {
        expId(v) {
            if(v) {
                this.curExpId = v
            }
        }
    },
    mounted() {
        this.getParcelData()
        /*return false
        let token = localStorage.getItem('as_user_token')
        if (!token && this.$route.query && this.$route.query.expressSearchUrl) {
            location.href = this.$route.query.expressSearchUrl
            return false
        } 
        if (token) {
            this.getParcelData()
        }*/
    },
    watch: {
        "$store.state.user"(v) {
            if (v.id && this.expItem.memberId && this.expItem.memberId != v.id) {
                // 当前包裹memberId和登录的id不相等，跳转查询物流信息
                this.skipParcel()
            }
        }
    },
    methods: {
        skipParcel() {
            //location.href = this.expressSearchUrl
            let url = "https://m.kuaidi100.com/result.jsp?nu=" + this.expItem.expressNo
            location.href = url
        },
        getParcelData() {
            this.expItem = {}
            let query = this.$route.query;
            let expId = this.$route.params.expId;
            /*this.expressSearchUrl = query.expressSearchUrl // 有直接跳转的地址则跳转
            if (this.expressSearchUrl) {
                this.expressSearchUrl = decodeURIComponent(this.expressSearchUrl)
            }*/
            this.showH5Loading();
            this.$axios.get(window.consts.apis.getParcelById + '?id=' + this.curExpId).then(res => {
                this.hideH5Loading()
                if (res.success) {
                    this.expItem = res.result
                    //this.tailIsShow = true
                } else {
                    // 失败后两秒跳转查询物流信息
                    /*this.$toast.fail({
                        duration: 2000,
                        forbidClick: true,
                        loadingType: 'spinner',
                        message: res.error.message,
                        onClose: (rt => {
                            this.skipParcel()
                        })
                    });*/
                    return false
                }
            }).catch(e => {
                this.hideH5Loading()
                // 失败后跳转查询物流信息
                //this.skipParcel()
                //this.$toast.fail('获取邮单失败!')
                return false
            })
        },
        //图片上传之前
        beforeAvatarUpload (file) {
            /*const isLt2M = file.size / 1024 / 1024 < 5
            if (!isLt2M) {
                this.$toast.fail('身份证图片大小不能超过5MB!')
                return false
            }*/
            return true
        },
        //身份证人面像
        idCardFrontImageSuccess (res, file) {
            this.showH5Loading()
            lrz(res.file, {
                width: 1000,
                quality: 0.7
            }).then(rst => {
                let fd = new FormData()
                fd.append("File", rst.file)
                this.$axios.post(window.consts.apis.uploadFile, rst.formData, { // fd
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": this.uploadHeaders.Authorization
                    }
                }).then(r => {
                    this.hideH5Loading()
                    if (r.success) {
                        this.expItem.addressee.idCardFrontImageUrl = r.result.fileUrl
                    } else {
                        this.$toast.fail(r.error.message)
                    }
                }, error => {
                    this.hideH5Loading()
                    this.$toast.fail("身份证上传失败，请重试!")
                })
            }).catch(e => {
                this.hideH5Loading()
                this.$toast.fail("上传出错啦，请重试!")
            })
        },
        //身份证国徽像
        idCardBackImageSuccess (res, file) {
            this.showH5Loading()
            lrz(res.file, {
                width: 1000,
                quality: 0.7
            }).then(rst => {
                let fd = new FormData()
                fd.append("File", res.file)
                this.$axios.post(window.consts.apis.uploadFile, rst.formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": this.uploadHeaders.Authorization
                    }
                }).then(r => {
                    this.hideH5Loading()
                    if (r.success) {
                        this.expItem.addressee.idCardBackImageUrl = r.result.fileUrl
                    } else {
                        this.$toast.fail(r.error.message)
                    }
                }, error => {
                    this.hideH5Loading()
                    this.$toast.fail("身份证上传失败，请重试!")
                })
            }).catch(e => {
                this.hideH5Loading()
                this.$toast.fail("上传出错啦，请重试!")
            })
        },
        save() {
            var item = this.expItem.addressee
            var valid = window.consts.validate;
            if (!valid.idCard.test(item.idCardNo)) {
                this.$toast.fail("身份证格式错误!");
                return false;
            } else if (!item.idCardFrontImageUrl || !item.idCardBackImageUrl) {
                this.$toast.fail("请上传身份证图片!");
                return false;
            }
            let pars = {
                "idCardNo": this.expItem.addressee.idCardNo,
                "idCardFrontImageUrl": this.expItem.addressee.idCardFrontImageUrl,
                "idCardBackImageUrl": this.expItem.addressee.idCardBackImageUrl,
                "id": this.expItem.id
            }
            this.showH5Loading()
            this.$axios.post(window.consts.apis.submitIdCardInfo, pars).then(r => {
                this.hideH5Loading()
                if (r.success) {
                    this.$toast.success({
                        duration: 2000,
                        forbidClick: true,
                        loadingType: 'spinner',
                        message: "身份证信息保存成功!"
                    });
                } else {
                    this.$dialog.alert({ message: r.error.message });
                    return false;
                }
            }).catch(e => {
                this.hideH5Loading();
                this.$toast.fail("出错啦，请稍候再试!");
                return false;
            })
        },
        toTail() {
            this.skipParcel()
        },
        closeTail() {
            this.$emit("closeTail")
        }
    }
}
</script>